<div class="wrapper">
	<ion-icon (click)="dismiss()" class="cross" src="../../../assets/topgolf/cross.svg"></ion-icon>
	<h3 class="title">{{ 'promocode.title' | translate }}</h3>
	<div class="promo-img">
		<ion-icon src="../../../assets/topgolf/add_promo_img.svg"></ion-icon>
	</div>
	<p class="description">{{ 'promocode.description' | translate }}</p>
	<div class="input-section">
		<ion-input [formControl]="enterForm"></ion-input>
		<p class="error-message">
			{{ promoError }}
		</p>
	</div>

	<div class="footer">
		@if (loading) {
			<ion-spinner></ion-spinner>
		}
		@if (!loading) {
			<ion-button (click)="checkPromoCode()" [disabled]="!enterForm?.value">{{ 'promocode.button' | translate }} </ion-button>
		}
	</div>
</div>
